import { get, keys, forEach, find, toNumber } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { ColorConfigInActive as InActiveColorLegend } from 'config/piechart-configs/resolution-config';

/*************************************************************/

/**
 * @type {class}
 * @desc CallResolutionReporting defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CallResolutionReportingService } from 'services/callResolutionReporting';
 *
 * // create service instance and send/cancel request
 * const callResolutionReportingService = new CallResolutionReportingService();
 * const result = await callResolutionReportingService.fetchData( '<user-id>' ); // fetch data
 * callResolutionReportingService.cancel(); // cancel an active request
 */
export class CallResolutionReportingService extends HttpService {

       // make request and fetch data
       async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract widgets from the response
            const visibility = get( response, 'body.component.visibility', {} );
            const structure = get( response, 'body.component.structure', {} );
            const filterData = get( response, 'body.component.data.state', {} );
            const options = get( response, 'body.component.data.options', {} );

    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    structure,
                    visibility,
                    filterData,
                    options
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // make request and fetch data  for graphs
    async fetchGraphData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            // extract widgets from the response
            const values = get( response, 'body.component.data.state.values', {} );

            // modify data for bar graphs
            const graphData = [];

            forEach( values, value => {
                graphData.push( {
                    name: value.duration,
                    id: value.duration,
                    value: value.value,
                    labelText: `${ value.value } (${ get( value, 'percentageValue' ) }%)`
                } );
            } );

            // extract widgets from the response
            const structure = get( response, 'body.component.structure', {} );
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    config: structure,
                    chartData: graphData,
                    totalCalls: get( response, 'body.component.data.state.totalCalls', {} )
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    async fetchPieChartData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );

            const optionKey = get( response, 'body.component.structure.reportConfig.options', '' );

            // get the options
            const options = get( response, 'body.component.data.state.options', {} )[ optionKey ];

            // get the pie chart values
            const values = get( response, 'body.component.data.state.values', {} );

            const pieChartData = [];

            forEach( keys( values ), ( categoryVal, index ) => {

                const option = find( options, { value: categoryVal } );

                pieChartData.push( {
                    
                    // name: option.name,
                    // id: option.value,
                    // value: Number( get( get( values, categoryVal, {} ), 'value' ) ),
                    // percentageValue: `${ get( get( values, categoryVal, {} ), 'percentageValue' ) }%`,
                    // tooltip: `${ option.name } (${ get( get( values, categoryVal, {} ), 'percentageValue' ) }%)`,

                    name: get( option, 'name' ),
                    percentageValue: values[ categoryVal ].percentageValue +'%',
                    y: toNumber( values[ categoryVal ].value ),
                    color: InActiveColorLegend[ index ]
                } );
            } );
            
            // extract data from the response
            const structure = get( response, 'body.component.structure', {} );
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    config: structure,
                    chartData: pieChartData,
                    totalCalls: get( response, 'body.component.data.state.totalCalls', {} ),
                    duration: get( response, 'body.component.data.state.duration', '' )
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
